import React from 'react';
import {Route} from 'react-router-dom';
import AsyncPage from './async';

export default [
  <Route
    key="/business/products/face-reshaping"
    exact
    path="/business/products/face-reshaping"
    component={AsyncPage}
  />,
];
